export default __webpack_public_path__ + "static/media/mobile_dev.2964943a.svg";